// export const globalURL = 'http://216.48.189.197:8080';
// export const globalURL = 'https://ekyc.kalolytic.com';
export const globalURL = 'https://fincokyc.kalolytic.com';
// export const globalURL = 'https://216.48.189.197:8080';
